import React from 'react';
import { useFormState } from 'react-final-form';

import BaseSettingCard from '@dashboard/components/platform-settings/BaseSettingCard';
import SectionSeparator from '@dashboard/components/SectionSeparator';
import { alertError, alertSuccess } from '@dashboard/contexts/SnackbarManager/store';
import {
  type UpdateWorkflowMutationVariables,
  useCreateWorkflowPreviewMutation,
} from '@dashboard/generated/wp/platform';
import { Box, Button, Stack, Typography } from '@mui/material';

import { useCustomPreviewData } from '../FormContext';

import PreviewWorkflowRun from './PreviewWorkflowRun';

export default function TestWorkflowSection() {
  const [value] = useCustomPreviewData();
  const { values } = useFormState<UpdateWorkflowMutationVariables>();
  const [createPreview, { data, loading }] = useCreateWorkflowPreviewMutation();

  const onClick = async () => {
    try {
      await createPreview({
        variables: {
          id: values.id,
          stepDefinitions: values.stepDefinitions,
          variables: JSON.parse(value),
        },
      });
      alertSuccess('Workflow test run created');
    } catch (e) {
      alertError('Workflow test run failed');
    }
  };

  return (
    <>
      <SectionSeparator />
      <BaseSettingCard title="Test workflow">
        <Stack spacing={3}>
          <Typography color="text.secondary">
            Test your workflow to verify if it's working as expected. We'll use your test data from above (you can
            modify your data as needed before running).
          </Typography>
          <Box>
            <Button disabled={loading} onClick={onClick} variant="outlined" size="small">
              Run workflow with test data
            </Button>
            <PreviewWorkflowRun workflowRunId={data?.createWorkflowPreview?.id || null} />
          </Box>
        </Stack>
      </BaseSettingCard>
    </>
  );
}
